<template>
  <HPopup class="h-naga-bank-popup"
          ref="popup"
          v-show="visible">
    <div class="h-naga-bank-popup-body">
      <p class="popup-header">蛇妖宝屋</p>

      <div class="visit-intro h-bg brown-2 h-outer-border around-4 bw2 bz0 white ls-1 fs-12 center">
        <p>你发现了蛇妖宝屋，想和他的卫兵开战吗？</p>
        <p class="count h-title nowrap"
           data-title="今日可挑战次数"
           :class="{ limited: visitCount >= maxCount }">
          ({{visitCount}} / {{maxCount}})
        </p>
      </div>

      <div class="levels">
        <div class="level-item cursor-default h-bg brown-2 h-outer-border around-4 bw2 bz0 "
             :class="{
              locked: unlockedLevel < index,
              selected: selectedIndex === index,
              'not-open h-title nowrap': item.notOpen
             }"
             :data-title="item.notOpen ? '暂未开放' : ''"
             v-for="(item, index) in levels"
             @click="handleSelectLevel(item, index)">
          <p class="level-num center ls-1 fs-12 gold">
            第{{ index + 1 }}层
          </p>
          <img class="lock"
               :src="`${$rHost}/img/common/icon/icon_lock.png`" alt="">
        </div>
      </div>

      <template v-if="selectedData">
        <div class="guard-info h-outer-border around-1 h-bg brown-2">
          <!-- 英雄信息 -->
          <div class="hero-box cursor-default sep-line">
            <!-- 头像 -->
            <div class="hero-avatar h-outer-border around-4 bz0 bw2">
              <img :src="selectedData.avatar" alt="">
            </div>
            <!-- 信息 -->
            <div class="hero-info h-outer-border around-4 bz0 bw2">
              <p class="title">蛇妖卫兵</p>
            </div>
          </div>

          <!-- 生物 -->
          <div class="troops cursor-default sep-line">
            <div class="avatar-wrapper h-outer-border around-4 bz0 bw2"
                 v-for="(d, i) in selectedData.troop">
              <template v-if="d && Object.keys(d).length">
                <img :src="troopUrl(Object.keys(d)[0])" alt="">
                <div class="amount white">{{ Object.values(d)[0] || '' }}</div>
              </template>
            </div>
          </div>

          <div class="bonus-list h-bg brown-2 h-outer-border around-4 bz0 bw2 cursor-default">
            <div class="bonus-item h-title nowrap"
                 :data-title="bonusTitle(item)"
                 v-for="item in bonusList">
              <img class="bonus-icon" :class="['bonus-' + item.name]" :src="getBonusIconUrl(item.name)" alt="">
            </div>
          </div>
        </div>
      </template>

      <div class="footer">
        <button v-click-sound-button
                class="h-btn normal"
                @click="handleAttack">
          挑战
        </button>
        <button v-click-sound-button
                class="h-btn normal"
                @click="handleClose">
          离开
        </button>
      </div>
    </div>
  </HPopup>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import HPopup from '@/components/h-popup/index.vue'
  import API from '@js/api'
  import game from '@js/game'
  import * as GameSocket from '@js/game-socket'
  import WS_TP from '@js/config/socket'
  import AudioCtrl from '@js/audio-ctrl'
  import AUDIO from '@/js/constants/AUDIO'

  const { getResourceUrl, getArtifactUrl } = game

  export default {
    beforeDestroy () {
      if (this.audioId) {
        AudioCtrl.stop(this.audioId)
      }
    },

    data () {
      return {
        maxCount: 0,
        unlockedLevel: 0,
        visitCount: 0,
        levels: [],
        selectedIndex: 0,
        audioId: null,
      }
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),
      ...mapGetters('hero', [
        'actionPoint',
      ]),

      ...mapGetters('gameData', [
        'animationSpeed',
      ]),

      selectedData () {
        return this.levels[this.selectedIndex]
      },

      bonusList () {
        if (!this.selectedData) {
          return []
        }
        return [
          ...this.selectedData.bonus?.must.map((d) => {
            return d
          }).filter((d) => d),
          ...this.selectedData.bonus?.may.map((d) => {
            return d
          }).filter((d) => d)
        ]

      },
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
      this.getNagaBankLevels()
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.NagaBank, loop: false })
    },

    methods: {
      ...mapActions('hero', []),

      bonusTitle (bonus = {}) {
        const amountText = bonus.isProbability ? '有几率获得': `${bonus.min} ~ ${bonus.max}`
        return `${bonus.nameCn}: ${amountText}`
      },

      getBonusIconUrl (id) {
        if (typeof id === 'string') {
          return getResourceUrl(id)
        }
        return getArtifactUrl(id)
      },

      troopUrl (name) {
        return `${this.$rHost}/img/creature/avatar/${name}.jpg`
      },

      async getNagaBankLevels () {
        try {
          const data = await API.game.getNagaBankLevels({
            visitId: 'NagaBank'
          })
          this.maxCount = data.maxCount
          this.unlockedLevel = data.unlockedLevel
          this.visitCount = data.visitCount
          this.levels = data.levels
        } catch (err) {
          console.error(err)
          this.$message(err)
        }
      },

      handleSelectLevel (item, index) {
        if (index > this.unlockedLevel) {
          return
        }

        if (item?.notOpen) {
          return
        }

        this.selectedIndex = index
      },

      handleAttack () {
        if (this.visitCount >= this.maxCount) {
          this.$message('今日次数已达上限')
          return
        }

        if (this.actionPoint <= 0) {
          this.$message('行动力不足')
          return
        }

        if (this.selectedIndex > this.unlockedLevel) {
          return
        }
        GameSocket.socket.emit(WS_TP.CLIENT.VISIT_BUILDING, {
          visitId: 'NagaBank',
          animationSpeed: +this.animationSpeed,
          level: this.selectedIndex + 1
        })
      },

      handleClose () {
        this.$emit('close', false)
      }
    },

    components: {
      HPopup,
    }
  }
</script>

<style lang="stylus" scoped>
  .bonus-list
    flex-grow 1
    display flex
    padding 5px
    font-size 12px
    justify-content space-around
    .bonus-item
      display flex
      justify-content center
      align-items center
      .bonus-icon
        box-sizing border-box
        width 24px
        vertical-align top
        filter drop-shadow(0 0 3px #000)
        &.bonus-exp
          padding 1px
        &.bonus-ore,
        &.bonus-wood
          padding 3px

  .h-naga-bank-popup-body
    position relative
    z-index 1
    width 650px
    > .content
      justify-content space-between
      > .col
        &:first-child
          width 300px
        &:last-child
          width calc(100% - 300px - 5px)

  .visit-intro
    display flex
    padding 2px 5px
    line-height 24px
    justify-content space-between
    .count
      color $colorGreen1
      text-shadow 1px 1px 1px #000
    .limited
      font-weight bold
      color $colorRed1

  .levels
    margin-top 20px
    display flex
    justify-content space-between
    flex-wrap wrap
    .level-item
      position relative
      display flex
      justify-content center
      align-items center
      width 110px
      height 40px
      padding 3px
      &:nth-child(n + 6)
        margin-top 10px
      &.locked,
      &.not-open
        filter grayscale(0.9)
        cursor not-allowed
        .lock
          display block
      &.selected
        outline 2px solid $colorGold
      .lock
        display none
        position absolute
        bottom 2px
        right 2px
        width 20px
        height 20px

  .guard-info
    margin-top 20px
    display flex
    justify-content flex-start
    border-width 6px
    padding 1px

  .hero-box
    position relative
    display flex
    .hero-avatar
      overflow hidden
      display flex
      justify-content center
      align-items center
      width 44px
      height 44px
      > img
        width 100%
        vertical-align top
    .hero-info
      display flex
      flex-direction column
      justify-content center
      align-items center
      width 70px
      height 44px
      padding 4px 0
      > p
        font-size 12px
        line-height 18px
        letter-spacing 1px
        transform-origin center
      .nick
        goldText1()
      .title
        whiteText1()

  .troops
    display flex
    user-select none
    .avatar-wrapper
      position relative
      overflow hidden
      display flex
      justify-content center
      align-items flex-start
      width 44px
      height 44px
      > img
        width 100%
      > .amount
        position absolute
        width 100%
        bottom 1px
        left 0
        padding-right 3px
        text-align right
        font-size 12px
        transform-origin right bottom
        transform scale(0.83, 0.83)
      &.selected
        z-index 1
        outline 1px solid $colorRed

  .sep-line
    position relative
    margin-right 4px
    &:before
      content ""
      position absolute
      top 0
      right -4px
      width 3px
      height 100%
      background-image linear-gradient(to right, #000, #f7df7b, #000)

  .footer
    margin-top 30px
    display flex
    justify-content space-evenly
    > button
      box-sizing content-box
      border 2px solid $colorGold

</style>
